import {useCallback, useMemo} from "react";
import {useApiOperation} from "./useApiOperation";


interface CreateRecalculationJobStatus {
    recalculationJobId: string | null;
    loading: boolean;
    error: string | null;
}

type Return = [
    (after: string | Date, before: string | Date, recalculatedBefore: string | Date, locale?: string) => Promise<unknown>,
    CreateRecalculationJobStatus
];

export function useCreateRecalculationJob(): Return {
    const url = '/api/recalculationJobs.create';
    const [request, {data, error, loading}] = useApiOperation(url);

    const recalculationJobId = useMemo(() => {
        return data && data.recalculationJobId ? data.recalculationJobId : null;
    }, [data]);

    const makeRequest = useCallback((after: string | Date, before: string | Date, recalculatedBefore: string | Date, locale?: string) => {
        const payload = {
            after,
            before,
            recalculatedBefore,
            ...(locale && { locale })
        };
        return request(payload);
    }, [request]);

    return [makeRequest, {
        recalculationJobId,
        loading,
        error
    } as CreateRecalculationJobStatus]
}
